/*  MUI  */
import { Box, Grid, Paper, Tab } from '@mui/material';

/*  Shared  */
import { PageTitle } from 'application/Shared/Components/App';
import { MUITabsWrapper } from 'application/Shared/Components/MUITabsWrapper';
import { Route } from 'application/Shared/Helpers';
import { Contracts } from 'application/Shared/Pages';

/* Hooks */
import { useFetchTenantApplicationLinkAllContracts } from 'hooks/dataAccess/Tenant/ApplicationLink/tenantApplicationLinkContract';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router';

/*  Components  */
import { ContractCalendar } from './Pages/ContractCalendar';
import { ContractList } from './Pages/ContractList';

export const AdminContractsDashboard = () => {
    const { t } = useTranslation();
    const { clientId, partnerId, tab } = useParams();
    const activeTab = tab ?? 'details';

    const { contracts, loading: loadingCalendarInfo } =
        useFetchTenantApplicationLinkAllContracts({
            clientId
        });

    const baseAdminRoute = Route.buildBaseAdminRoute({
        clientId,
        partnerId
    });

    return (
        <Box data-testid="adminContracts">
            <PageTitle title={t('ContractManagement.title')} />
            <Grid container spacing={3} data-testid="adminContractsTabs">
                <Grid item xs={12}>
                    <MUITabsWrapper value={activeTab}>
                        <Tab
                            component={Link}
                            to={`${baseAdminRoute}/contracts/details`}
                            value="details"
                            label={t('Common.details')}
                            data-testid="adminContractsTabsMain"
                            data-trackid="admin_contracts_details"
                        />
                        <Tab
                            component={Link}
                            to={`${baseAdminRoute}/contracts/calendar`}
                            value="calendar"
                            label={t('ContractManagement.calendar')}
                            data-testid="adminContractsTabsCalendar"
                            data-trackid="admin_contracts_calendar"
                        />
                        <Tab
                            component={Link}
                            to={`${baseAdminRoute}/contracts/list`}
                            value="list"
                            label={t('ContractManagement.contracts')}
                            data-testid="adminContractsTabsList"
                            data-trackid="admin_contracts_list"
                        />
                    </MUITabsWrapper>
                </Grid>
            </Grid>
            {activeTab === 'details' && <Contracts />}
            {activeTab === 'calendar' && (
                <Paper
                    elevation={0}
                    variant="outlined"
                    data-trackid="adminContractPagesCalendar"
                    style={{ padding: '16px' }}
                >
                    <ContractCalendar
                        allEvents={contracts}
                        loading={loadingCalendarInfo}
                    />
                </Paper>
            )}
            {activeTab === 'list' && <ContractList />}
        </Box>
    );
};
